var _path, _g, _path2, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIlustraExcluir(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 299 299",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_404_7051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 34,
    y: 33,
    width: 230,
    height: 230
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1074 148.384C34.1074 211.615 85.3666 262.872 148.597 262.872C211.827 262.872 263.085 211.615 263.085 148.384C263.085 85.1535 211.827 33.8954 148.597 33.8954C85.3666 33.8954 34.1074 85.1535 34.1074 148.384",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_404_7051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17578 148.879C8.17578 217.957 70.6845 273.956 147.794 273.956C224.904 273.956 287.413 217.957 287.413 148.879C287.413 79.8006 224.904 23.8022 147.794 23.8022C70.6845 23.8022 8.17578 79.8006 8.17578 148.879Z",
    fill: "#F9EDEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.74 95.8504C139.333 104.138 140.926 104.664 143.1 109.906C143.389 110.603 143.584 111.547 142.453 112.53C142.03 112.896 141.494 113.192 140.974 113.425C136.728 115.324 134.442 113.284 133.719 111.071C131.57 104.493 133.227 95.7889 128.48 90.7872C124.663 86.7658 116.931 85.452 114.806 80.3826C114.532 79.7294 114.484 78.7803 115.583 77.876C116.161 77.3988 116.901 77.08 117.586 76.8186C127.224 73.1451 134.098 75.7684 136.632 80.3055C139.164 84.8436 138.685 91.0341 140.74 95.8504Z",
    fill: "#DDA166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.851 92.6465C152.444 100.934 154.038 101.46 156.212 106.703C156.501 107.4 156.695 108.343 155.565 109.325C155.141 109.693 154.606 109.988 154.085 110.221C149.84 112.119 147.554 110.08 146.831 107.867C144.682 101.289 146.338 92.585 141.591 87.5833C137.774 83.5619 130.043 82.2481 127.917 77.1787C127.643 76.5255 127.596 75.5764 128.694 74.6711C129.273 74.1949 130.012 73.8761 130.698 73.6136C140.335 69.9402 147.209 72.5645 149.743 77.1016C152.275 81.6387 151.796 87.8302 153.851 92.6465Z",
    fill: "#E8AC6B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.724 56.1806C129.662 58.332 122.009 64.5433 117.632 67.3499C103.086 76.6762 86.833 81.5696 70.5266 86.9995C69.2587 87.4214 68.1325 87.3569 67.1886 86.9745C66.9959 87.1641 66.7906 87.3423 66.6083 87.5402C64.9477 89.3561 63.7465 91.5158 63.3631 93.9151C62.9797 96.3144 63.7194 98.8345 65.156 100.697C66.5927 102.561 68.7263 103.766 71.1287 103.537L70.5974 104.147L70.0671 104.755C72.4925 103.593 75.022 102.416 77.5911 101.651C80.1602 100.885 82.7668 100.528 85.3474 101.011C86.8726 101.296 88.3009 101.862 89.6876 102.535C91.0753 103.208 92.4213 103.988 93.785 104.702C96.9167 106.342 100.349 107.659 103.864 108.28C107.379 108.9 110.973 108.828 114.426 107.688C116.6 106.97 118.694 105.844 120.809 104.909C122.923 103.974 125.059 103.232 127.316 103.281C129.751 103.335 131.912 104.296 134.008 105.499C136.104 106.703 138.135 108.149 140.307 109.173C143.03 110.456 146.404 110.841 149.41 110.193C152.418 109.546 155.061 107.867 156.326 105.022C155.039 102.385 152.894 100.48 150.407 98.922C147.922 97.3655 145.094 96.1581 142.443 94.9173C139.79 93.6754 137.061 92.0783 134.952 90.0489C132.844 88.0194 131.355 85.5576 131.186 82.5854C131.15 81.9509 131.195 81.2779 131.373 80.658C131.551 80.0381 131.86 79.4703 132.351 79.0474C132.743 78.7098 133.223 78.5806 133.725 78.4931C134.226 78.4056 134.749 78.3587 135.224 78.1868C138.479 77.0137 148.778 74.4634 152.634 76.7606C156.489 79.0578 155.332 86.5484 157.715 89.5697C158.921 91.1001 158.566 91.2126 159.416 91.6856C160.265 92.1586 160.887 92.643 161.186 94.2214C161.641 93.7723 162.165 93.4046 162.738 93.1639C163.312 92.9233 163.935 92.8087 164.583 92.866C165.416 92.941 165.27 93.8786 165.122 94.8037C164.975 95.7289 164.826 96.6425 165.654 96.6654C165.652 96.6113 166.623 95.6559 167.595 94.7006C168.567 93.7452 169.54 92.7899 169.541 92.7336C164.671 81.5571 168.794 75.7417 164.824 69.7117C159.993 64.8152 149.456 62.867 146.574 59.2279C143.348 57.7309 140.442 55.9639 136.724 56.1806Z",
    fill: "#FCC380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.1533 128.721L80.9144 120.375C87.6956 119.237 92.3139 112.758 91.1763 105.977L86.585 78.6023C85.4473 71.8212 78.9683 67.2038 72.1872 68.3405L22.4261 76.6864C15.6449 77.8241 11.0276 84.3031 12.1642 91.0843L16.7565 118.459C17.8931 125.241 24.3722 129.858 31.1533 128.721Z",
    fill: "#D91C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.6072 129.483L85.4612 119.612C89.742 118.894 92.657 114.804 91.9382 110.523L91.2193 106.233L16.961 118.688C16.8725 118.703 16.811 118.788 16.8266 118.878L17.5184 123.005C18.2362 127.286 22.3264 130.201 26.6072 129.483Z",
    fill: "#CE1D61"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M164.594 91.4624C163.783 92.9752 163.247 94.5399 163.087 96.2527C162.967 97.5341 162.932 100.193 163.785 101.284C163.902 101.432 164.38 102.43 164.475 101.494C164.007 101.187 163.731 100.76 163.647 100.211C163.525 99.7417 163.461 99.2646 163.456 98.7791C163.304 96.7538 163.614 94.8077 164.306 92.9074C165.457 89.7528 160.425 88.3933 159.283 91.5229C157.589 96.1693 157.075 105.721 163.786 106.613C166.408 106.963 169.001 105.152 169.289 102.453C169.431 101.117 168.779 100.093 168.458 98.8499C168.028 97.1851 168.286 95.5963 169.091 94.0909C170.673 91.1374 166.179 88.5027 164.594 91.4624Z",
    fill: "#FCC380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.141 86.319L146.287 75.0809C143.278 74.1381 140.045 75.8279 139.101 78.8367L125.883 121.011C124.939 124.02 126.63 127.254 129.638 128.197L165.493 139.435C168.501 140.378 171.735 138.688 172.678 135.679L185.896 93.5043C186.84 90.4956 185.15 87.2618 182.141 86.319Z",
    fill: "#F9F186"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.446 105.506L170.483 115.548",
    stroke: "#DCD96C",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.265 112.465L147.957 116.13",
    stroke: "#DCD96C",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.777 119.327L150.555 124.586",
    stroke: "#DCD96C",
    strokeWidth: 5.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M171.672 108.856L142.018 99.5612C140.643 99.1309 139.87 97.6526 140.301 96.2774L144.276 83.5986C144.706 82.2234 146.184 81.4514 147.558 81.8817L177.213 91.1767C178.589 91.608 179.361 93.0864 178.931 94.4615L174.956 107.14C174.525 108.515 173.046 109.288 171.672 108.856Z",
    fill: "#DCD96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.872 73.2769C144.929 77.291 150.854 77.7046 157.102 77.6411C160.452 77.6078 160.46 72.3987 157.102 72.432C152.495 72.4789 147.366 72.6196 143.555 69.5931C140.956 67.5303 137.245 71.1923 139.872 73.2769Z",
    fill: "#FCC380"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.408 98.9225C147.922 97.366 145.093 96.1586 142.442 94.9167C139.79 93.6759 137.061 92.0789 134.952 90.0494C133.785 88.9263 132.82 87.6647 132.152 86.2645C121.369 87.8314 110.472 88.5138 99.6901 90.0379C99.6203 90.762 99.3723 91.5184 98.891 92.2841C96.5032 96.0794 95.4197 100.579 94.8467 105.238C97.6867 106.627 100.742 107.728 103.864 108.28C107.378 108.901 110.973 108.828 114.426 107.688C116.599 106.97 118.694 105.844 120.808 104.91C122.924 103.974 125.059 103.231 127.316 103.281C129.75 103.335 131.912 104.296 134.008 105.499C136.105 106.703 138.134 108.15 140.307 109.173C143.03 110.456 146.403 110.841 149.411 110.194C152.418 109.546 155.061 107.866 156.326 105.021C155.038 102.384 152.894 100.479 150.408 98.9225Z",
    fill: "#FCC380"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_404_7051",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 299,
    height: 299
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0L299 0L299 299L0 299L0 0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_404_7051)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M249.044 183.581C242.724 178.567 234.478 176.049 226.434 176.674C225.498 176.746 224.329 176.741 223.904 175.903C223.698 175.495 223.751 175.007 223.85 174.561C224.457 171.843 226.742 169.576 229.463 168.99C230.341 168.8 231.373 168.699 231.858 167.945C232.184 167.439 232.148 166.785 232.049 166.192C231.741 164.361 230.938 162.54 231.291 160.718C231.645 158.896 234.026 157.383 235.352 158.682C235.842 159.163 236.041 159.895 236.572 160.328C237.676 161.231 239.264 160.337 240.644 159.976C243.049 159.347 245.815 160.766 246.707 163.087C248.203 166.979 244.881 172.129 247.686 175.215C248.722 176.356 250.424 176.889 251.095 178.278C252.235 180.636 249.567 183.34 250.137 185.896",
    fill: "#F9F084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.827 168.92C237.178 168.92 237.184 163.711 233.827 163.711C230.475 163.711 230.469 168.92 233.827 168.92Z",
    fill: "#DCD96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.045 173.672C249.397 173.672 249.403 168.463 246.045 168.463C242.694 168.463 242.688 173.672 246.045 173.672Z",
    fill: "#DCD96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.036 270.223H189.599C182.722 270.223 177.098 264.597 177.098 257.721L177.098 175.568H257.538V257.721C257.538 264.597 251.913 270.223 245.036 270.223Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.328 175.568V252.512C252.328 259.388 246.704 265.013 239.827 265.013H179.476C181.752 268.16 185.442 270.222 189.599 270.222H245.036C251.913 270.222 257.538 264.597 257.538 257.721V175.568H252.328Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 192.794L179.874 192.794",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 198.003L190.292 198.003",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.305 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.096 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.887 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.678 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.469 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.26 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.051 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.841 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.633 267.434V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.424 267.434V245.255",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.424 210.135V193.165",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.214 204.829V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.006 204.829V193.164",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.214 267.434V250.989",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.006 267.434V250.989",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 203.212H209.681",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 208.421H209.681",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 213.631H226.651",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 218.84H226.651",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 224.049H226.651",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 229.259H226.651",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 234.468H226.651",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 239.676H209.681",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 244.885H209.681",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 250.094H209.681",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 255.303L190.292 255.303",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 260.512H190.292",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.144 265.721H190.292",
    stroke: "#D0D2D3",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.574 233.803C124.21 239.041 118.802 242.928 112.764 244.445C110.846 244.928 108.767 245.229 107.281 246.532C105.189 248.367 104.989 251.563 105.474 254.304C105.958 257.044 106.97 259.752 106.723 262.524C106.612 263.777 106.243 265.037 106.475 266.273C106.938 268.746 109.707 270.209 112.222 270.152C114.737 270.093 117.069 268.923 119.371 267.908C121.672 266.894 124.199 265.997 126.659 266.521C131.051 267.457 133.512 272.458 137.771 273.879C140.534 274.801 143.775 273.947 145.816 271.87C147.857 269.793 148.658 266.613 147.967 263.783C147.652 262.496 147.022 261.242 145.98 260.422C144.881 259.557 143.256 259.039 142.966 257.671C142.514 255.543 145.53 254.658 147.164 253.222C149.096 251.525 149.15 248.59 149.055 246.022C148.908 242.028 148.225 237.206 144.551 235.632C140.289 233.806 135.651 237.928 131.032 237.523C128.655 237.314 125.52 236.243 124.424 238.363",
    fill: "#F9F084"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.441 252.609C123.207 251.723 122.975 250.838 122.743 249.951C122.431 248.769 121.377 248.137 120.231 248.039C115.739 247.656 113.869 254.686 117.834 256.698C119.048 257.314 120.713 257.057 121.397 255.763C122.024 254.577 121.76 252.858 120.463 252.199C120.223 252.066 120.278 252.125 120.629 252.379C120.438 252.19 120.485 252.264 120.77 252.603C120.515 252.179 120.965 253.209 120.814 252.733C120.674 252.289 120.801 253.405 120.839 252.802C120.848 252.593 120.829 252.705 120.781 253.136C120.797 253.04 120.819 252.946 120.845 252.853C121.039 252.376 120.584 253.367 120.8 252.94C121.101 252.346 120.526 253.172 120.814 252.911C120.709 252.99 120.604 253.068 120.499 253.149C120.731 253.011 120.643 253.037 120.233 253.227C120.622 253.112 119.533 253.189 120.231 253.249C119.393 252.611 118.557 251.974 117.719 251.336C117.952 252.222 118.185 253.108 118.418 253.993C118.764 255.311 120.294 256.243 121.622 255.812C122.977 255.374 123.812 254.021 123.441 252.609Z",
    fill: "#DCD96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.761 250.112C137.988 249.588 139.333 250.598 138.661 249.966C138.743 250.044 139.019 250.682 138.899 250.331C138.821 250.137 138.821 250.155 138.899 250.383C138.962 250.673 138.966 250.631 138.912 250.259C139.008 250.425 138.8 251.262 138.945 250.524C138.683 251.856 139.322 253.398 140.764 253.727C142.054 254.021 143.687 253.338 143.968 251.908C144.461 249.395 143.513 247.051 141.39 245.615C140.259 244.848 138.454 245.36 137.827 246.548C137.131 247.866 137.554 249.294 138.761 250.112Z",
    fill: "#DCD96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.065 268.076C141.416 268.076 141.423 262.867 138.065 262.867C134.713 262.867 134.707 268.076 138.065 268.076Z",
    fill: "#DCD96C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.062 192.234H178.352C173.914 192.234 170.283 188.603 170.283 184.165V183.637C170.283 179.199 173.914 175.568 178.352 175.568H257.062C261.5 175.568 265.131 179.199 265.131 183.637V184.165C265.131 188.603 261.5 192.234 257.062 192.234Z",
    fill: "#E6E7E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.062 175.568H251.853C256.291 175.568 259.921 179.198 259.921 183.636V184.165C259.921 188.603 256.291 192.233 251.853 192.233H257.062C261.5 192.233 265.13 188.603 265.13 184.165V183.636C265.13 179.198 261.5 175.568 257.062 175.568Z",
    fill: "#D0D2D3"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.4141 161.845C78.4141 167.085 82.6782 171.349 87.9185 171.349C93.1588 171.349 97.423 167.085 97.423 161.845C97.423 156.605 93.1588 152.34 87.9185 152.34C82.6782 152.34 78.4141 156.605 78.4141 161.845ZM80.4977 161.845C80.4977 157.753 83.8263 154.424 87.9185 154.424C92.0108 154.424 95.3394 157.753 95.3394 161.845C95.3394 165.937 92.0108 169.266 87.9185 169.266C83.8263 169.266 80.4977 165.937 80.4977 161.845Z",
    fill: "#D91C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.0863 210.698C57.0863 213.012 55.21 214.887 52.8962 214.887C50.5823 214.887 48.707 213.012 48.707 210.698C48.707 208.383 50.5823 206.509 52.8962 206.509C55.21 206.509 57.0863 208.383 57.0863 210.698Z",
    fill: "#D91C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.533 184.668L133.374 182.155L135.887 176.998C136.264 176.222 135.942 175.287 135.167 174.909C134.388 174.532 133.455 174.852 133.077 175.628L130.564 180.786L125.405 178.275C124.628 177.898 123.694 178.219 123.316 178.996C122.938 179.772 123.261 180.706 124.036 181.085L129.195 183.597L126.683 188.755C126.305 189.531 126.627 190.466 127.402 190.845C127.623 190.951 127.857 191.002 128.087 191.002C128.665 191.002 129.221 190.681 129.492 190.124L132.005 184.966L137.164 187.478C137.384 187.585 137.617 187.636 137.848 187.636C138.426 187.636 138.983 187.313 139.253 186.758C139.631 185.982 139.308 185.046 138.533 184.668Z",
    fill: "#D91C5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.299 89.1299L232.388 85.1033C233.003 84.498 233.01 83.5083 232.404 82.8936C231.8 82.28 230.81 82.2716 230.194 82.8769L226.107 86.9035L222.079 82.8144C221.476 82.2008 220.485 82.1924 219.87 82.7988C219.255 83.4041 219.248 84.3927 219.854 85.0085L223.88 89.0965L219.791 93.1231C219.177 93.7284 219.168 94.7171 219.775 95.3328C220.08 95.6433 220.484 95.7985 220.888 95.7985C221.284 95.7985 221.68 95.6495 221.984 95.3495L226.073 91.3229L230.1 95.411C230.404 95.7214 230.809 95.8777 231.213 95.8777C231.609 95.8777 232.006 95.7277 232.31 95.4276C232.923 94.8223 232.932 93.8337 232.325 93.2179L228.299 89.1299Z",
    fill: "#D91C5C"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIlustraExcluir);
export default __webpack_public_path__ + "static/media/ilustra-excluir.7c4901873368dcaf0b4a9eaf2e51d94a.svg";
export { ForwardRef as ReactComponent };